import React, {useState, useEffect} from 'react';
import {Panel } from 'framework7-react';

import './LeftPanel.css';
import {VERSION} from "../pages/loginHome/LoginHome";
import Icon from "../icon/Icon";
import models from '../../model/models';
import ChooseGroupPopup from '../popups/chooseGroupPopup/ChooseGroupPopup';
import TrainingVideosPopup from '../popups/trainingVideosPopup/TrainingVideosPopup';
import loginController from '../../controllers/loginController';
import offlineSyncController from '../../controllers/offlineSyncController';
import offlineStorageModel from '../../model/offlineStorageModel';
import utils from "../../utils/utils";

const LeftPanel = () => {
	const [group, setGroup] = useState(null);
	const [numPendingOfflineActions, setNumPendingOfflineActions] = useState(0);
	const [hotUpdateAvailable, setHotUpdateAvailable] = useState(false);

	const updateViewData = () => {
		const currentGroup = models.user_group.obj();
		const numPending = offlineStorageModel.numPending();
		setGroup(currentGroup);
		setNumPendingOfflineActions(numPending);
		setHotUpdateAvailable(window.hotUpdateAvailable || false);
	};

	useEffect(() => {
		const subId = models.user_group.onChange(updateViewData);
		const offlineSubId = offlineStorageModel.onChange(updateViewData);
		updateViewData();

		const handleHotUpdate = () => {
			setHotUpdateAvailable(true);
		};
		document.addEventListener('chcp_updateIsReadyToInstall', handleHotUpdate);

		return () => {
			models.user_group.unsubscribe(subId);
			offlineStorageModel.unsubscribe(offlineSubId);
			document.removeEventListener('chcp_updateIsReadyToInstall', handleHotUpdate);
		};
	}, []);

	const closeMenu = () => {
		window.f7.panel.close();
	};

	useEffect(() => {
		const handleEscape = (e) => {
			if (e.key === 'Escape') {
				closeMenu();
			}
		};

		window.addEventListener('keydown', handleEscape);
		return () => {
			window.removeEventListener('keydown', handleEscape);
		};
	}, []);

	const showDrugs = () => {
		closeMenu();
	};

	const showGroups = () => {
		window.popupController.show(ChooseGroupPopup);
		closeMenu();
	};

	const showTrainingVideos = () => {
		window.popupController.show(TrainingVideosPopup);
		closeMenu();
	};

	const showLogin = () => {
		localStorage.clear();
		loginController.show();
		closeMenu();
		utils.hardReloadApp();
	};

	const handleOfflineSync = () => {
		offlineSyncController.start();
		closeMenu();
	};

	const handleUpdateApp = () => {
		if (window.installHotUpdate) {
			window.installHotUpdate();
		} else {
			console.warn('Update function not available');
		}
		closeMenu();
	};

	return (
		<Panel left reveal layout="light" className={'g-left-panel'}>

	<aside className="drawer" role="dialog" aria-modal="true" aria-label="Menu">
		<div className="drawer-header">
			<div className="brand-row">
				<div className="brand">
					<div className="appname">LogRx</div>
					<div className="agency">{group?.name || 'Loading...'}</div>
				</div>
			</div>

		</div>

		<nav className="menu">
			<div className="section-label">Main</div>

			<div className="item active" role="button" tabIndex="0" onClick={showDrugs}>
				<div className="icon" aria-hidden="true">
					<Icon className={'small-icon'} name="vial-fill-white"/>
				</div>
				<div className="text">
					<div className="label">Drugs</div>
					<div className="sub">Inventory, scan, waste</div>
				</div>
			</div>

			<div className="item" role="button" tabIndex="0" onClick={showTrainingVideos}>
				<div className="icon" aria-hidden="true">
					<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
						<path d="M10 8l8 4-8 4V8Z" fill="currentColor"/>
						<path d="M12 22a10 10 0 1 0-10-10 10 10 0 0 0 10 10Z" stroke="currentColor" strokeOpacity=".35"
									strokeWidth="2"/>
					</svg>
				</div>
				<div className="text">
					<div className="label">Training Videos</div>
					<div className="sub">Quick refreshers</div>
				</div>
			</div>
			{numPendingOfflineActions > 0 && (
			<div className="item" role="button" tabIndex="0" onClick={handleOfflineSync}>
				<div className="icon " aria-hidden="true">
					<svg className="offline" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
						<path d="M2.5 8.5C8.4 3.7 15.6 3.7 21.5 8.5" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
						<path d="M5.7 11.6c4.2-3.3 8.4-3.3 12.6 0" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
						<path d="M8.9 14.8c2.1-1.6 4.1-1.6 6.2 0" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
						<path d="M12 18.8h0" stroke="currentColor" strokeWidth="4.4" strokeLinecap="round"/>
						<path d="M4 4l16 16" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round"/>
					</svg>
				</div>
				<div className="text">
					<div className="label">Offline Actions</div>
					<div className="sub">press to sync</div>
				</div>

					<div className="badge badge-green">{numPendingOfflineActions}</div>

			</div>
			)}

			<div className="divider"></div>

			<div className="section-label">Account</div>

			<div className="item" role="button" tabIndex="0" onClick={showGroups}>
				<div className="icon" aria-hidden="true">
					<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
						<path d="M4 20V7a2 2 0 0 1 2-2h6v15H4Z" stroke="currentColor" strokeWidth="2"/>
						<path d="M12 20V4h6a2 2 0 0 1 2 2v14H12Z" stroke="currentColor" strokeWidth="2"/>
						<path d="M7 9h2M7 12h2M7 15h2M15 8h2M15 11h2M15 14h2" stroke="currentColor" strokeWidth="2"
									strokeLinecap="round"/>
					</svg>
				</div>
				<div className="text">
					<div className="label">Agency</div>
					<div className="sub">{group?.name || 'Loading...'}</div>
				</div>
			</div>

			{hotUpdateAvailable && (
			<div className="item" role="button" tabIndex="0" onClick={handleUpdateApp}>
				<div className="icon" aria-hidden="true">
					<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
						<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
						<path d="M21 3v5h-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
						<path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
						<path d="M3 21v-5h5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
					</svg>
				</div>
				<div className="text">
					<div className="label">Update App</div>
					<div className="sub">Check for updates</div>
				</div>
			</div>
			)}

			<div className="logout">
				<div className="item danger" role="button" tabIndex="0" onClick={showLogin}>
					<div className="icon" aria-hidden="true">
						<svg width="18" height="18" viewBox="0 0 24 24" fill="none">
							<path d="M10 7V6a2 2 0 0 1 2-2h7a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-7a2 2 0 0 1-2-2v-1" stroke="currentColor"
									strokeWidth="2"/>
							<path d="M4 12h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
							<path d="M7 9l-3 3 3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round"
									strokeLinejoin="round"/>
						</svg>
					</div>
					<div className="text">
						<div className="label">Log-out</div>
						<div className="sub">End session</div>
					</div>
				</div>
			</div>
		</nav>

		<div className="drawer-footer">
			<span>v{VERSION}</span>
			{/*<span style={{opacity: 0.8}}>Last sync: 2m</span>*/}
		</div>
	</aside>
		</Panel>
	);
};

export default LeftPanel;

